<template>
  <div v-if="!canPlaceOrder"
    class="alert alert-warning text-center d-flex align-items-center justify-content-center p-3"
    role="alert"
  >
    <i class="fas fa-exclamation-triangle mr-2 fa-lg"></i>
    <span class="font-weight-bold h5">
      You must enable at least one Age Group to place an Order.
    </span>
  </div>

  <div class="app-content content m-0">
    <div class="content-overlay"></div>

    <div class="content-wrapper">
      <div class="content-body">
        <PlaceOrder
          v-if="canPlaceOrder"
          :currentUser="currentUser"
          :customer="customer"
          :vendor="vendor"
          :rmm="rmm"

          :jerseys="jerseys"
          :oldJerseys="oldJerseys"
          :newJerseys="newJerseys"
          :oldVariants="oldVariants"
          :newVariants="newVariants"
          :variants="variants"

          :shorts="shorts"
          :shortsVariants="shortsVariants"

          :socks="socks"
          :socksVariants="socksVariants"
          :oldSocks="oldSocks"
          :newSocks="newSocks"
          :oldSocksVariants="oldSocksVariants"
          :newSocksVariants="newSocksVariants"

          :balls="balls"
          :ballsVariants="ballsVariants"

          :medals="medals"
          :medalsVariants="medalsVariants"

          :enabledSportsSite="enabledSportsSite"
          :notifications="notifications"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import PlaceOrder from './PlaceOrder.vue';

  export default {
    components: {
      PlaceOrder
    },
    data() {
      return {
        currentUser: {
          name: '',
        },
        customer: {
          club_name: '',
          age_groups: [],
          translations: {
            welcome: '',
            from: '',
          }
        },
        vendor: null,
        rmm: null,

        jerseys: null,
        oldJerseys: null,
        newJerseys: null,
        oldVariants: null,
        newVariants: null,
        variants: null,
        shorts: null,
        shortsVariants: null,
        socks: null,
        socksVariants: null,
        oldSocks: null,
        newSocks: null,
        oldSocksVariants: null,
        newSocksVariants: null,
        balls: null,
        ballsVariants: null,
        medals: null,
        medalsVariants: null,

        enabledSportsSite: '',
        notifications: []
      };
    },
    computed: {
      canPlaceOrder() {
        return this.customer.age_groups.length > 0;
      }
    },
    mounted() {
      const data = document.getElementById('vue-app').dataset.currentUser;
      if (data) {
        const parsedData = JSON.parse(data);
        this.currentUser = parsedData.user;
        this.customer = parsedData.customer;
        this.vendor = parsedData.vendor;
        this.rmm = parsedData.rmm;

        this.jerseys = parsedData.jerseys;
        this.oldJerseys = parsedData.old_jerseys;
        this.newJerseys = parsedData.new_jerseys;
        this.oldVariants = parsedData.old_variants;
        this.newVariants = parsedData.new_variants;
        this.variants = parsedData.variants;

        this.shorts = parsedData.shorts || []; // [] in case of Hockey season
        this.shortsVariants = parsedData.shorts_variants || [];// [] in case of Hockey season

        this.socks = parsedData.socks || []; // Array of hashes
        this.oldSocks = parsedData.old_socks || [];
        this.newSocks = parsedData.new_socks || [];

        this.socksVariants = parsedData.socks_variants || [];// A single array with a single hash in case of Hockey Season
        this.oldSocksVariants = parsedData.old_socks_variants || [];
        this.newSocksVariants = parsedData.new_socks_variants || [];

        this.balls = parsedData.balls || []; // [] in case of Hockey season
        this.ballsVariants = parsedData.balls_variants || []; // [] in case of Hockey season

        this.medals = parsedData.medals;
        this.medalsVariants = parsedData.medals_variants;

        this.enabledSportsSite = parsedData.enabled_sports_site;
        this.notifications = parsedData.notifications;
      }
    }
  };
</script>
